import axios from "axios";

export const createToolTip = async (username, tooltipVOToCreate) => {
    try {
        const {data} = await axios.post("/api/tooltip/create", {username, tooltipVOToCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateToolTip = async (username, tooltipVOToUpdate) => {
    try {
        const {data} = await axios.put("/api/tooltip/update", {username, tooltipVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveToolTip = async (username, tooltipExternalReference) => {
    try {
        const {data} = await axios.post("/api/tooltip/view", {username, tooltipExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllToolTips = async (username) => {
    try {
        const {data} = await axios.get("/api/tooltip/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}